import { render, staticRenderFns } from "./FlowOutputs.vue?vue&type=template&id=2188aafa&scoped=true&"
import script from "./FlowOutputs.vue?vue&type=script&lang=js&"
export * from "./FlowOutputs.vue?vue&type=script&lang=js&"
import style0 from "./FlowOutputs.vue?vue&type=style&index=0&id=2188aafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188aafa",
  null
  
)

export default component.exports